import { Status } from 'api/common/statuses'
import { NoticeSimplified, PaymentAlert } from 'api/common/types'
import myPageAPI from 'api/myPage'
import { paymentAlertAPI } from 'api/paymentAlert'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { NoticeListCard } from 'components/NoticeListCard'
import { PaymentAlertCard } from 'components/PaymentAlertCard'
import { QrCode } from 'components/QrCode'
import AUBEQuestDeal from 'images/deal_aube_quest.png'
import * as React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'
import { PaymentAlertResponse } from 'api/common/responses'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [mainPositionId, setMainPositionId] = React.useState(0)
  const [connectorEmail, setConnectorEmail] = React.useState('')
  const [connectorName, setConnectorName] = React.useState('')
  const [notices, setNotices] = React.useState<NoticeSimplified[]>([])
  const [paymentAlerts, setPaymentAlerts] = React.useState<PaymentAlert[]>([])
  const [showModal, setShowModal] = React.useState(false)
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else {
      paymentAlertAPI((status: Status, result: PaymentAlertResponse) => {
        if (status === Status.Success) {
          setPaymentAlerts(result.paymentAlerts)
        }
      })
      myPageAPI((status, result) => {
        if (status === Status.Success) {
          setMainPositionId(result.mainPositionId)
          setConnectorName(result.connectorName)
          setConnectorEmail(result.connectorEmail)
          setNotices(result.notices)
        }
      })
    }
  }, [navigate])

  /**
   * 「ログアウト」ボタン
   */
  const handleLogoutButton = () => {
    loginData.clear()
    navigate('/')
  }
  return (
    <>
      <Header title="マイページ" />
      <main>
        <section className="bg-white px-4 pb-3">
          {paymentAlerts.map((paymentAlert: PaymentAlert, index: number) => (
            <PaymentAlertCard paymentAlert={paymentAlert} key={index} />
          ))}
        </section>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">お知らせ</h3>
          {notices.map((notice, index) => (
            <NoticeListCard notice={notice} key={index} />
          ))}
          <div className="mt-3">
            <Button variant="primary" className="w-100 py-4" href="/notificationList">
              お知らせ一覧を表示
            </Button>
          </div>
        </section>
        <section className="bg-white px-4 py-5">
          <div>
            <div className="fw-bold">コネクター名</div>
            <hr className="my-2" />
            <div>{connectorName}</div>
          </div>
          <div className="mt-5">
            <div className="fw-bold">メールアドレス</div>
            <hr className="my-2" />
            <div>{connectorEmail}</div>
          </div>
          <div className="mt-5">
            <div className="fw-bold">コネクターID（メインポジション）</div>
            <hr className="my-2" />
            <div>{mainPositionId}</div>
          </div>
          <div className="mt-4">
            <Button variant="outline-primary" className="w-100 py-4" onClick={() => setShowModal(true)}>
              QRコードを表示
            </Button>
            <Modal size="sm" show={showModal} onHide={() => setShowModal(false)} aria-labelledby="contained-modal-title-vcenter" centered>
              <Modal.Body className="text-center">
                <QrCode targetString={mainPositionId.toString()} />
              </Modal.Body>
            </Modal>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href="/connectorEdit">
              コネクター情報を変更する
            </Button>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href="/passwordEdit">
              パスワードを変更する
            </Button>
          </div>
          <div className="mt-5">
            <div className="fw-bold">AUBEクエストディール</div>
            <hr className="my-2" />
            <div className="reflection">
              <img src={AUBEQuestDeal} alt="AUBEクエストディール" className="w-100" />
            </div>
          </div>
        </section>
        <section className="bg-white px-4 py-5">
          <div>
            <Button variant="danger" className="w-100 py-4" onClick={handleLogoutButton}>
              ログアウト
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
      <style>{`
        .reflection {
          display:inline-block;
          position:relative;
          overflow:hidden;
        }

        .reflection:after {
          content:"";
          height:100%;
          width:30px;
          position:absolute;
          top:-180px;
          left:0;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 32%, rgba(255, 255, 255, 1) 85%, rgba(255, 255, 255, 0) 100%);
          opacity:0;
          -webkit-transform: rotate(-30deg);
          -webkit-animation: reflection 8s ease-in-out infinite;
        }

        @keyframes reflection {
          0% { -webkit-transform: scale(0) rotate(45deg);opacity: 0; }
          60% { -webkit-transform: scale(0) rotate(45deg);opacity: 0; }
          70% { -webkit-transform: scale(5) rotate(45deg);opacity: 1; }
          100% { -webkit-transform: scale(200) rotate(45deg);opacity: 0; }
        }
        `}</style>
    </>
  )
}

export default SceneComponent
